import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

export default function HeroSection() {
  const hotArticles = getHotArticles();
  const featured1 = hotArticles[0];
  const featured2 = hotArticles[1];
  const featured3 = hotArticles[2];

  if (!featured1) return null;

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={featured1.coverImage}
          alt=""
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/25 to-foreground-950/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="lg:col-span-3">
            <div className="flex flex-col justify-end h-full min-h-[360px] md:min-h-[420px]">
              <div className="flex flex-wrap items-center gap-2 mb-3">
                <span className="text-xs bg-primary-500 text-background-50 px-3 py-1 rounded-full font-semibold whitespace-nowrap">头条</span>
                <span className="text-xs text-background-50/70 whitespace-nowrap">{featured1.category}</span>
              </div>
              <Link to={`/article/${featured1.slug}`}>
                <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 leading-tight mb-3 hover:text-primary-300 transition-colors duration-200 line-clamp-3">
                  {featured1.title}
                </h2>
              </Link>
              <p className="text-sm md:text-base text-background-50/80 line-clamp-2 mb-4 leading-relaxed max-w-2xl">{featured1.summary}</p>
              <div className="flex items-center gap-4 text-xs text-background-50/60">
                <span className="whitespace-nowrap">{featured1.publishDate}</span>
                <span className="whitespace-nowrap">{featured1.viewCount.toLocaleString()} 阅读</span>
                <span className="whitespace-nowrap">{featured1.commentCount.toLocaleString()} 评论</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-4">
            {featured2 && (
              <Link
                to={`/article/${featured2.slug}`}
                className="group flex-1 relative rounded-lg overflow-hidden min-h-[160px]"
              >
                <img
                  src={featured2.coverImage}
                  alt={featured2.title}
                  className="w-full h-full object-cover object-top absolute inset-0 group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                  title={featured2.title}
                />
                <div className="absolute inset-0 bg-foreground-950/40"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-sm md:text-base font-heading font-semibold text-background-50 line-clamp-2 leading-snug">
                    {featured2.title}
                  </h3>
                  <span className="text-xs text-background-50/60 mt-1 block whitespace-nowrap">{featured2.publishDate}</span>
                </div>
              </Link>
            )}
            {featured3 && (
              <Link
                to={`/article/${featured3.slug}`}
                className="group flex-1 relative rounded-lg overflow-hidden min-h-[160px]"
              >
                <img
                  src={featured3.coverImage}
                  alt={featured3.title}
                  className="w-full h-full object-cover object-top absolute inset-0 group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                  title={featured3.title}
                />
                <div className="absolute inset-0 bg-foreground-950/40"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-sm md:text-base font-heading font-semibold text-background-50 line-clamp-2 leading-snug">
                    {featured3.title}
                  </h3>
                  <span className="text-xs text-background-50/60 mt-1 block whitespace-nowrap">{featured3.publishDate}</span>
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}